import { env } from '@/env/env';

export default {
    url: env(process.env.VUE_APP_API_URL, 'https://noobizes.myno.io/api'),
    withCredentials: false,
};
